var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"light","content":_vm.tipList[_vm.titInd]}},[_c('img',{attrs:{"src":require('@/assets/imgs/shop/uesrIcon' + (_vm.titInd + 1) + '.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }